import React, { useState } from "react";
import { View, StyleSheet, ScrollView } from "react-native";
import CustomText from "../../../common/general/CustomText/CustomText";
import { AssignmentSuggestionCard, AssignmentSuggestion } from "../AssignmentSuggestionCard/AssignmentSuggestionCard";

export interface AssignmentGroup {
  courseName: string;
  courseCode?: string | null;
  assignments: AssignmentSuggestion[];
}

interface AssignmentSuggestionCardListProps {
  title: string;
  groups: AssignmentGroup[];
  onAssignmentPress: (assignment: AssignmentSuggestion) => void;
  showCourseHeaders?: boolean;
}

export const AssignmentSuggestionCardList: React.FC<AssignmentSuggestionCardListProps> = ({
  title,
  groups,
  onAssignmentPress,
  showCourseHeaders = true,
}) => {
  const [hoveredId, setHoveredId] = useState<string | null>(null);

  if (groups.length === 0) {
    return null;
  }

  return (
    <View style={styles.container}>
      <CustomText text={title} useTranslationText={false} style={styles.title} />
      <ScrollView style={styles.scrollView} contentContainerStyle={styles.scrollContent}>
        <View style={styles.groupsContainer}>
          {groups.map((group, groupIndex) => (
            <View key={groupIndex} style={styles.courseSection}>
              {showCourseHeaders && (
                <CustomText
                  text={group.courseCode ? `${group.courseName} (${group.courseCode})` : group.courseName}
                  useTranslationText={false}
                  style={styles.courseName}
                />
              )}
              {group.assignments.map((assignment) => (
                <AssignmentSuggestionCard
                  key={assignment.id}
                  assignment={assignment}
                  onPress={onAssignmentPress}
                  isHovered={hoveredId === assignment.id}
                  onMouseEnter={() => setHoveredId(assignment.id)}
                  onMouseLeave={() => setHoveredId(null)}
                />
              ))}
            </View>
          ))}
        </View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: "100%",
    marginTop: 32,
    maxHeight: 400,
    paddingHorizontal: 16,
  },
  title: {
    fontSize: 16,
    fontWeight: "600",
    color: "#101828",
    marginBottom: 16,
  },
  scrollView: {
    flexGrow: 0,
    flexShrink: 1,
  },
  scrollContent: {
    paddingBottom: 8,
  },
  groupsContainer: {
    gap: 20,
  },
  courseSection: {
    marginBottom: 12,
  },
  courseName: {
    fontSize: 12,
    fontWeight: "600",
    color: "#667085",
    textTransform: "uppercase",
    letterSpacing: 0.5,
    marginBottom: 8,
    paddingHorizontal: 4,
  },
});
